/* Clean System Group – CSG 2026 téma, közös JS */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CSG = window.CSG = window.CSG || {};
  var VAT = 1 + ((CSG.vat || 27) / 100);
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  CSG.store = store;
  var fmt = CSG.fmt = function (cents) {
    return String(Math.round((cents || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' Ft';
  };
  var esc = CSG.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Bruttó / nettó ---------- */
  var net = store.get('csg_vat', 'g') === 'n';
  function paintPrices(root) {
    $$('[data-c]', root).forEach(function (el) {
      var c = parseInt(el.getAttribute('data-c'), 10);
      if (isNaN(c)) return;
      el.textContent = fmt(net ? c / VAT : c) + (el.hasAttribute('data-from') ? '-tól' : '');
    });
  }
  CSG.paintPrices = paintPrices;
  function setVat(n) {
    net = n; store.set('csg_vat', n ? 'n' : 'g');
    document.documentElement.classList.toggle('is-net', n);
    $$('.vat button').forEach(function (b) { b.setAttribute('aria-pressed', String((b.dataset.vat === 'n') === n)); });
    paintPrices();
  }
  $$('.vat button').forEach(function (b) { b.addEventListener('click', function () { setVat(b.dataset.vat === 'n'); }); });
  if (net) setVat(true);

  /* ---------- Header ---------- */
  var hdr = $('.hdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var openItem = null, closeT;
  function closeMega() { if (openItem) { openItem.classList.remove('is-open'); var b = $('.nav__a', openItem); if (b) b.setAttribute('aria-expanded', 'false'); openItem = null; } }
  $$('.nav__i[data-mega]').forEach(function (li) {
    var btn = $('.nav__a', li);
    var open = function () { clearTimeout(closeT); if (openItem && openItem !== li) closeMega(); li.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); openItem = li; };
    li.addEventListener('mouseenter', function () { if (matchMedia('(hover:hover)').matches) open(); });
    li.addEventListener('mouseleave', function () { closeT = setTimeout(closeMega, 140); });
    btn.addEventListener('click', function (e) {
      if (li.classList.contains('is-open') && btn.tagName === 'A' && !matchMedia('(hover:hover)').matches) return;
      if (btn.tagName === 'A' && matchMedia('(hover:hover)').matches) return;
      e.preventDefault(); li.classList.contains('is-open') ? closeMega() : open();
    });
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(); var f = $('.mega a', li); if (f) f.focus(); } });
    li.addEventListener('focusout', function () { setTimeout(function () { if (!li.contains(document.activeElement)) { li.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); if (openItem === li) openItem = null; } }, 0); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMega(); closeDrawer(); closeSearch(); } });

  /* Drawer */
  var drawer = $('#drawer'), lastFocus;
  function openDrawer() { if (!drawer) return; lastFocus = document.activeElement; drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; var c = $('.drawer__x', drawer); if (c) c.focus(); }
  function closeDrawer() { if (!drawer || !drawer.classList.contains('is-open')) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });

  /* ---------- Kereső ---------- */
  var srch = $('#srch'), sInput = srch && $('input[type=search]', srch), sRes = srch && $('[data-srch-res]', srch), sHint = srch && $('[data-srch-hint]', srch), sCtl, sT;
  function openSearch(q) {
    if (!srch) return; lastFocus = document.activeElement;
    srch.classList.add('is-open'); srch.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    if (typeof q === 'string') { sInput.value = q; runSearch(); }
    setTimeout(function () { sInput.focus(); sInput.select(); }, 30);
  }
  function closeSearch() { if (!srch || !srch.classList.contains('is-open')) return; srch.classList.remove('is-open'); srch.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  CSG.openSearch = openSearch;
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openSearch(); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', closeSearch); });
  document.addEventListener('keydown', function (e) { if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) { e.preventDefault(); openSearch(); } });
  $$('form[data-hsearch]').forEach(function (f) {
    f.addEventListener('submit', function (e) { var v = $('input[type=search]', f).value.trim(); if (!v) { e.preventDefault(); openSearch(''); } });
  });
  function runSearch() {
    var q = sInput.value.trim();
    clearTimeout(sT);
    if (q.length < 2) { sRes.innerHTML = ''; sHint.hidden = false; return; }
    sT = setTimeout(function () {
      if (sCtl) sCtl.abort();
      sCtl = 'AbortController' in window ? new AbortController() : null;
      var u = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.sku,vendor,tag,body';
      fetch(u, { signal: sCtl ? sCtl.signal : undefined }).then(function (r) { return r.json(); }).then(function (j) {
        var R = (j.resources && j.resources.results) || {}, h = '';
        var P = R.products || [], C = R.collections || [], PG = (R.pages || []).concat(R.articles || []);
        if (P.length) {
          h += '<div class="srch__grp"><p>Termékek</p>' + P.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : (p.image || '');
            var price = parseFloat(p.price) || 0;
            var pr = price > 0 && price < (CSG.quoteAny || 500000) ? fmt(Math.round(price * 100) / (net ? VAT : 1)) : 'Ár ajánlatra';
            return '<a class="srow" href="' + esc(p.url) + '"><span class="srow__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span><span><b>' + esc(p.title) + '</b><small>' + esc(p.vendor || '') + '</small></span><span class="srow__p">' + pr + '</span></a>';
          }).join('') + '</div>';
        }
        if (C.length) h += '<div class="srch__grp"><p>Kategóriák</p><div class="chips" style="padding:4px 8px 8px">' + C.map(function (c) { return '<a class="chip" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') + '</div></div>';
        if (PG.length) h += '<div class="srch__grp"><p>Oldalak, cikkek</p>' + PG.slice(0, 4).map(function (c) { return '<a class="srow" href="' + esc(c.url) + '" style="grid-template-columns:1fr"><span><b>' + esc(c.title) + '</b></span></a>'; }).join('') + '</div>';
        if (!h) h = '<div class="srch__empty">Nincs találat erre: „' + esc(q) + '”. Próbálja más szóval, vagy <a class="link" href="/pages/contact?tema=Árajánlat&termek=' + encodeURIComponent(q) + '">kérjen ajánlatot</a> – beszerezzük.</div>';
        else h += '<div class="srch__all"><a class="btn btn--sm btn--line" href="/search?type=product&options[prefix]=last&q=' + encodeURIComponent(q) + '">Összes találat →</a></div>';
        sHint.hidden = true; sRes.innerHTML = h;
      }).catch(function () {});
    }, 180);
  }
  if (sInput) {
    sInput.addEventListener('input', runSearch);
    sInput.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var rows = $$('.srow', sRes); if (!rows.length) return; e.preventDefault();
      var i = rows.indexOf(document.activeElement); i = e.key === 'ArrowDown' ? Math.min(rows.length - 1, i + 1) : Math.max(0, i - 1); rows[i].focus();
    });
    sRes.addEventListener('keydown', function (e) {
      var rows = $$('.srow', sRes), i = rows.indexOf(document.activeElement);
      if (e.key === 'ArrowDown' && i > -1) { e.preventDefault(); (rows[i + 1] || rows[i]).focus(); }
      if (e.key === 'ArrowUp' && i > -1) { e.preventDefault(); i === 0 ? sInput.focus() : rows[i - 1].focus(); }
    });
  }

  /* ---------- Kosár ---------- */
  var cartCount = $$('[data-cart-count]');
  function setCount(n) { cartCount.forEach(function (el) { el.textContent = n; el.hidden = false; }); }
  function refreshCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      setCount(c.item_count); document.dispatchEvent(new CustomEvent('csg:cart', { detail: c })); return c;
    }).catch(function () {});
  }
  CSG.refreshCart = refreshCart;
  var toast = $('#toast'), toastT;
  function showToast(ok, title, img, txt) {
    if (!toast) return;
    toast.classList.toggle('toast--err', !ok);
    $('.toast__img', toast).innerHTML = img ? '<img src="' + esc(img) + '" alt="">' : '';
    $('.toast__img', toast).hidden = !img;
    $('.toast__t b', toast).textContent = ok ? 'Kosárba került' : 'Nem sikerült';
    $('.toast__t span', toast).textContent = txt || title || '';
    $('.toast .btn', toast).hidden = !ok;
    toast.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toast.classList.remove('is-on'); }, 4200);
  }
  CSG.toast = showToast;
  function fly(fromEl) {
    var target = $('.cartbtn'); if (!fromEl || !target || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var r = fromEl.getBoundingClientRect(), t = target.getBoundingClientRect();
    if (!r.width) return;
    var size = Math.min(r.width, 160), f = document.createElement('div');
    f.className = 'fly'; f.style.cssText = 'left:' + (r.left + r.width / 2 - size / 2) + 'px;top:' + (r.top + r.height / 2 - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px';
    var src = fromEl.currentSrc || fromEl.src; if (src) f.innerHTML = '<img src="' + esc(src) + '" alt="">';
    document.body.appendChild(f);
    var dx = t.left + t.width / 2 - (r.left + r.width / 2), dy = t.top + t.height / 2 - (r.top + r.height / 2);
    requestAnimationFrame(function () { requestAnimationFrame(function () { f.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12)'; f.style.opacity = '.3'; }); });
    setTimeout(function () { f.remove(); target.classList.remove('is-bump'); void target.offsetWidth; target.classList.add('is-bump'); }, 720);
  }
  CSG.fly = fly;
  function addToCart(body, srcImg, title, btn) {
    if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
    return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        fly(srcImg);
        var it = j.items ? j.items[0] : j;
        setTimeout(function () { showToast(true, title, (srcImg && (srcImg.currentSrc || srcImg.src)) || (it && it.image), (it && it.product_title) || title); }, 380);
        if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1600); }
        return refreshCart();
      })
      .catch(function (e) { showToast(false, '', '', (e && (e.description || e.message)) || 'Próbálja újra, vagy hívjon minket.'); })
      .finally(function () { if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; } });
  }
  CSG.addToCart = addToCart;
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-ajax-cart]'); if (!f) return;
    if (!window.fetch || !window.FormData) return;
    if (!f.checkValidity()) return;
    e.preventDefault();
    var card = f.closest('[data-pc]') || f.closest('[data-pdp]');
    var img = card ? (card.querySelector('[data-fly]') || card.querySelector('img')) : null;
    addToCart(new FormData(f), img, f.getAttribute('data-title'), f.querySelector('[type=submit]'));
  });

  /* ---------- Ingyenes szállítás ---------- */
  var fs = $('#fs');
  if (fs) {
    var fb = $('.fs__btn', fs), fd = $('.fs__dlg', fs), fl = $('.fs__btn span', fs), base = fl.textContent, MIN = (CSG.freeMin || 15000) * 100;
    var openFs = function (v) { fd.hidden = !v; fb.setAttribute('aria-expanded', String(v)); if (v) $('.fs__x', fs).focus(); };
    fb.addEventListener('click', function (e) { e.stopPropagation(); openFs(fd.hidden); });
    $('.fs__x', fs).addEventListener('click', function () { openFs(false); fb.focus(); });
    fd.addEventListener('click', function (e) { e.stopPropagation(); });
    document.addEventListener('click', function () { if (!fd.hidden) openFs(false); });
    fd.addEventListener('keydown', function (e) { if (e.key === 'Escape') { openFs(false); fb.focus(); } });
    if ($('[data-fs-posted]', fs)) openFs(true);
    document.addEventListener('csg:cart', function (e) {
      var c = e.detail, t = c.items_subtotal_price, n = c.item_count, left = MIN - t, pr = $('[data-fs-prog]', fs);
      if (!n) { fl.textContent = base; fb.classList.remove('is-ok'); pr.hidden = true; return; }
      var pct = Math.min(100, Math.round(t / MIN * 100));
      if (left > 0) { fl.textContent = 'Még ' + fmt(left) + ' az ingyenes szállításig'; fb.classList.remove('is-ok'); pr.innerHTML = 'Még <b>' + fmt(left) + '</b>, és az első rendelés szállítása ingyenes.<i style="--p:' + pct + '%"></i>'; }
      else { fl.textContent = 'Ingyenes szállítás jár'; fb.classList.add('is-ok'); pr.innerHTML = '<b>Elérte a határt.</b> Első rendelésnél a pénztárban adja meg a kódot.<i style="--p:100%"></i>'; }
      pr.hidden = false;
    });
  }
  $$('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.getAttribute('data-copy'), t = b.textContent;
      var ok = function () { b.textContent = 'Kimásolva'; setTimeout(function () { b.textContent = t; }, 1600); };
      if (navigator.clipboard) navigator.clipboard.writeText(v).then(ok).catch(function () {}); else ok();
    });
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach(function (w) {
    var btns = $$('[role=tab]', w);
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { var on = x === b; x.setAttribute('aria-selected', String(on)); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
      });
      b.addEventListener('keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; var n = btns[(i + d + btns.length) % btns.length]; n.focus(); n.click(); });
    });
  });

  /* ---------- Reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.rv-in').forEach(function (el) { io.observe(el); });
  } else { $$('.rv-in').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Lightbox ---------- */
  $$('[data-lb]').forEach(function (wrap) {
    var items = $$('[data-full]', wrap);
    items.forEach(function (it, i) {
      it.addEventListener('click', function () {
        var idx = i, lb = document.createElement('div');
        lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true');
        lb.innerHTML = '<img alt=""><button class="lb-x" aria-label="Bezárás">✕</button>' + (items.length > 1 ? '<button class="lb-p" aria-label="Előző">‹</button><button class="lb-n" aria-label="Következő">›</button>' : '');
        var im = $('img', lb), show = function () { im.src = items[idx].getAttribute('data-full'); im.alt = items[idx].getAttribute('data-alt') || ''; };
        var close = function () { lb.remove(); document.removeEventListener('keydown', key); it.focus(); };
        var key = function (e) { if (e.key === 'Escape') close(); if (e.key === 'ArrowRight') { idx = (idx + 1) % items.length; show(); } if (e.key === 'ArrowLeft') { idx = (idx - 1 + items.length) % items.length; show(); } };
        lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('lb-x')) close(); if (e.target.classList.contains('lb-n')) { idx = (idx + 1) % items.length; show(); } if (e.target.classList.contains('lb-p')) { idx = (idx - 1 + items.length) % items.length; show(); } });
        document.addEventListener('keydown', key); document.body.appendChild(lb); show(); $('.lb-x', lb).focus();
      });
    });
  });

  /* ---------- Mennyiség gombok ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-btn]'); if (!b) return;
    var inp = b.parentNode.querySelector('input'); if (!inp) return;
    var min = parseInt(inp.min || '0', 10);
    inp.value = Math.max(min, (parseInt(inp.value, 10) || 0) + parseInt(b.getAttribute('data-qty-btn'), 10));
    inp.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Lista (mentett termékek) ---------- */
  CSG.list = {
    get: function () { return store.get('csg_list', []); },
    set: function (l) { store.set('csg_list', l.slice(0, 60)); },
    has: function (id) { return this.get().some(function (x) { return String(x.variant || x.id) === String(id); }); },
    toggle: function (item) {
      var l = this.get(), i = -1;
      l.forEach(function (x, k) { if (String(x.variant || x.id) === String(item.variant)) i = k; });
      if (i > -1) { l.splice(i, 1); this.set(l); return false; }
      l.unshift(item); this.set(l); return true;
    }
  };

  /* ---------- Filters drawer ---------- */
  $$('[data-facets-open]').forEach(function (b) { b.addEventListener('click', function () { var f = $('#facets'); if (f) { f.classList.add('is-open'); document.body.style.overflow = 'hidden'; } }); });
  $$('[data-facets-close]').forEach(function (b) { b.addEventListener('click', function () { var f = $('#facets'); if (f) { f.classList.remove('is-open'); document.body.style.overflow = ''; } }); });
  $$('form[data-facets-form]').forEach(function (f) {
    var auto = function () { if (matchMedia('(min-width:1021px)').matches) f.requestSubmit ? f.requestSubmit() : f.submit(); };
    f.addEventListener('change', function (e) { if (e.target.type === 'checkbox' || e.target.tagName === 'SELECT') auto(); });
    f.addEventListener('submit', function () {
      $$('input', f).forEach(function (i) { if ((i.type === 'number' || i.type === 'text') && !i.value) i.disabled = true; });
    });
  });
  $$('select[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
  });

  refreshCart();
})();
